import {RESOURCE_BY_COST_KIND, RESOURCE_RGB, type ResourceTone} from '@/constants/resourceTone';
import abilityAvailability from '@/services/abilityAvailabilityService.js';

export interface CostChip {
  tone: ResourceTone;
  rgb: string;
  value: number;
}

/**
 * The price of an action as the handful of numbers to print on its icon.
 *
 * Ordered Action Points → Energy → Health, the order the bars are stacked in,
 * so the eye moves the same way in both places. Kinds the action does not spend
 * are left out: a row of zeroes is noise, and most abilities cost one thing.
 */
export function resolveActionCosts(cost?: {kind: string; value: number}[] | null): CostChip[] {
  if (!Array.isArray(cost) || cost.length === 0) return [];

  return RESOURCE_BY_COST_KIND.flatMap(({kind, tone}) => {
    const value = abilityAvailability.costAmount(cost, kind);
    return value > 0 ? [{tone, rgb: RESOURCE_RGB[tone], value}] : [];
  });
}
